import { render, staticRenderFns } from "./ElCurrencyInput.vue?vue&type=template&id=c631e390&"
import script from "./ElCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./ElCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports